import { widthBiggerThan } from 'helpers/utils';

export const defaultSize = widthBiggerThan(1024) ? '20px' : widthBiggerThan() ? '28px' : '5.8vw';
export const defaultStroke = '2';
